import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import api from "../lib/api";
import { useStore } from "../context/StoreContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setAdmin } = useStore();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tn_token", data.token);
      setAdmin(data);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-inverse text-[color:var(--bg)] grain" data-testid="login-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="w-full max-w-md relative z-10">
        <div className="flex items-center gap-2 mb-8"><span className="w-3 h-3 bg-gold rotate-45" /><span className="font-display font-extrabold text-2xl">Panel Admin</span></div>
        <h1 className="font-display font-extrabold tracking-tighter text-4xl mb-8">Acceso restringido</h1>
        <form onSubmit={submit} className="space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email" required
            className="w-full bg-transparent border border-[color:var(--bg)]/20 px-4 py-3 outline-none focus:border-gold transition-colors text-[color:var(--bg)]" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" data-testid="login-password" required
            className="w-full bg-transparent border border-[color:var(--bg)]/20 px-4 py-3 outline-none focus:border-gold transition-colors text-[color:var(--bg)]" />
          {error && <p className="text-red-400 text-sm font-mono" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-gold text-inverse py-4 flex items-center justify-center gap-2 hover:bg-[color:var(--bg)] transition-colors font-medium disabled:opacity-60">
            <Lock className="w-4 h-4" /> {loading ? "Ingresando…" : "Ingresar"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
